import { Button } from '@grupoboticario/flora-react';
import { useWindowSize } from 'hooks';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

interface ShowMoreProps {
  hasMore?: boolean;
  setShowMore: (show: boolean) => void;
  size: number;
}

export function ShowMoreButton({
  hasMore,
  setShowMore,
  size,
}: Readonly<ShowMoreProps>) {
  const {
    breakpoints: { isLg, isXl },
  } = useWindowSize();
  if (hasMore) {
    return (
      <Button
        onClick={() => setShowMore(true)}
        hierarchy="tertiary"
        has="iconRight"
        icon={<FiChevronDown size={15} />}
      >
        Ver mais
      </Button>
    );
  }
  if (!hasMore && ((isLg && size > 4) || (isXl && size > 6))) {
    return (
      <Button
        onClick={() => setShowMore(false)}
        hierarchy="tertiary"
        has="iconRight"
        icon={<FiChevronUp size={15} />}
      >
        Ver menos
      </Button>
    );
  }
  return null;
}
